import { Component, ElementRef, inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core'; import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import { NgZorroModule } from '../../../shared/modules/ng-zorro/ng-zorro.module';
import { AccordionComponent } from '../../../shared/components/accordion/accordion.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { AssociationDetailsComponent } from './association-details/association-details.component';
import { BaseComponent } from '../../../shared/utils/base.component';
import { PROVIDER_TYPES, RADIO_YES_NO_OPTIONS, STATIC_DATA, STATIC_JSON_DATA_PATH } from '../../../shared/constants/static-data.constants';
import { SectionsService } from '../../../services/sections.service';
import { ReferralDataService } from '../../../services/referral-data.service';
import { EnrollmentDataService } from '../../../services/enrollment-data.service';
import { LoggerService } from '../../../shared/services/logger.service';
import { ProviderAssociationsComponent } from './provider-associations/provider-associations.component';
import { PopupDialogComponent } from '../../../shared/components/popup-dialog/popup-dialog.component';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { performValidation } from '../../../shared/utils/validation.util';
import { TableRowActionsModel } from '../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../shared/interfaces/actions';
import { AuthorizeDirective } from '../../../shared/authorization/authorize.directive.';
import { AuthorizeFieldDirective } from '../../../shared/authorization/authorizeField.directive';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { MEMBER_VIEW_PAGE_IDS, TABS } from '../../../shared/constants/page.constants';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { Router } from '@angular/router';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { environment } from '../../../../environments/environment';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { DatePickerComponent } from '../../../shared/components/date-picker/date-picker.component';
import { DialogConfig, DialogService } from '../../../shared/services/dialog.service';
import { FocusTrapDirective } from '../../../shared/directives/focus-trap.directive';
import { DropdownSelectComponent } from '../../../shared/components/dropdown-select/dropdown-select.component';
import { ListService } from '../../../shared/services/list.service';
import { AuthorizationService } from '../../../services/authorization.service';
import { AorWaiverComponent } from '../../enrollment/aor-waiver/aor-waiver.component';
import { LeadDetailIdentifiersAddUpdateModel } from '../../../interfaces/lead-detail.model';

@Component({
  selector: 'ppl-associations',
  standalone: true,
  imports: [ListTableComponent, CommonModule, NgZorroModule, ReactiveFormsModule, AccordionComponent,
    ButtonComponent, AssociationDetailsComponent, ProviderAssociationsComponent, DatePickerComponent,
    NzDatePickerModule, ModalComponent, NzAlertModule, PopupDialogComponent, AuthorizeDirective, AuthorizeFieldDirective,
    FocusTrapDirective, DropdownSelectComponent, AorWaiverComponent
  ],
  templateUrl: './associations.component.html',
  styleUrl: './associations.component.css'
})
export class AssociationsComponent extends BaseComponent implements OnInit {

  // mode is meant for internal it can be updated
  @Input() mode = 'read';

  // manually override the component to make it readonly
  @Input() readonly = false;
  radioOptions = RADIO_YES_NO_OPTIONS;
  newContactForm!: FormGroup;
  show = false;
  tabId = TABS.Associations;
  minStartDate?: Date;
  maxEndDate?: Date;

  associationDetailsData: any = {};
  prvdrAssociations: any = [];
  prvdrAssociationsStatus: any = [];

  cols: any[] = [];
  statusCols: any[] = [];
  selectedOption = '';
  weeklyLimitData: any;
  weeklyLimitCols =  [
    {
        "field": "svcDesc",
        "header": "Service Code",
        "jsonpath": "svcDesc",
        "isDisplayedAtHeader": "y",
        "isSearchable": "n"
    },
    {
        "field": "participantName",
        "header": "Consumer Name",
        "jsonpath": "participantName",
        "isDisplayedAtHeader": "y",
        "isSearchable": "n"
    },
    {
        "field": "startDate",
        "header": "Start Date",
        "jsonpath": "startDate",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
    },
    {
        "field": "endDate",
        "header": "End Date",
        "jsonpath": "endDate",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
    },
    {
      "field": "hoursFormatted",
      "header": "Weekly Limit Hours",
      "jsonpath": "hoursFormatted",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
        "field": "comments",
        "header": "Comments",
        "jsonpath": "comments",
        "isDisplayedAtHeader": "y",
        "isSearchable": "n"
    }
]

  actions: any = {
    "Add Status": false,
  }

  entry = '';
  consumerData: any;
  showModal: any;
  modalBody = '';
  program: any;
  selectedAssociationId = '';
  enrollmentStatus!: FormGroup;
  pendingBlockPayload: LeadDetailIdentifiersAddUpdateModel | null = null;
  allowedStatuses = ['Association Active', 'Association Active with Gap', 'In PPL Review', 'Paperwork Complete'];
  private dialogSvc = inject(DialogService);
  @ViewChild('manageStatusDialog') manageStatus!: TemplateRef<any>;
  @ViewChild('aorWaiverDialog') aorWaiverDialog!: TemplateRef<any>;
  @ViewChild('addStatusBtn') addStatusBtn!: ElementRef;
  @ViewChild('historyDialog') historyDialog!: TemplateRef<any>;
  @ViewChild('blockConfirmDialog') blockConfirmDialog!: TemplateRef<unknown>;
  blockConfirmDialogId: string | null = null;

  statusEntries: any[] = [
    {
      status: "In PPL Review"
    },
    {
      status: "Paperwork Complete"
    },
    {
      status: "Association Active"
    },
    {
      status: "Returned"
    },
    {
      status: "On Hold"
    },
    {
      status: "Blocked"
    },
    {
      status: "Disassociated"
    }
  ];
  allowedStatus: any[] = [];
  disableAddStatus = false;
  disableStatus = false;
  statusReasons: any[] = [];
  showMoveToInPPLReviewButton = false;
  participantStatus = '';
  actionButtons: TableRowActionsModel = new TableRowActions();
  weeklyLimitButtons: TableRowActions = new TableRowActions();
  isParticipant = true;
  leadId: any;
  isAssociationsEditable: boolean = false;
  isMobileView = window.innerWidth <= 768;
  userDetails: any;
  drActionsAllowed = false;
  pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
  historyData: any;
  selectedAorAssociationId = '';
  isAorEditable = false;
  isAorVisible = false;
  isPA = false;
  canBlockUnblock = false;
  assocData: any;
  historyCols = [
    {
      field: "tasAuthorizationXProviderId",
      header: "Id",
      jsonpath: "tasAuthorizationXProviderId"
    },
    {
      field: "svcDesc",
      header: "Service Code",
      jsonpath: "svcDesc"
    },
    {
      field: "participantName",
      header: "Consumer Name",
      jsonpath: "participantName"
    },
    {
      field: "startDate",
      header: "Start Date",
      jsonpath: "startDate"
    },
    {
      field: "endDate",
      header: "End Date",
      jsonpath: "endDate"
    },
    {
      field: "hours",
      header: "Weekly Limit Hours",
      jsonpath: "hours"
    },
    {
      field: "operation",
      header: "Operation",
      jsonpath: "operation"
    },
    {
      field: "createdByName",
      header: "Created By",
      jsonpath: "createdByName"
    },
    {
      field: "createdDate",
      header: "Created Date",
      jsonpath: "createdDate"
    },
    {
      field: "modifiedByName",
      header: "Modified By",
      jsonpath: "modifiedByName"
    },
    {
      field: "modifiedDate",
      header: "Modified Date",
      jsonpath: "modifiedDate"
    }
  ];

  constructor(
    private sectionsService: SectionsService,
    private fb: FormBuilder,
    private referralDataService: ReferralDataService,
    private enrollmentDataService: EnrollmentDataService,
    private logger: LoggerService,
    private leadDetailsService: LeadDetailsService,
    private router: Router,
    private authUtility: AuthorizationUtility,
    private userService: UserService,
    private storageService: StorageService,
    private listService: ListService,
    private authorizationService: AuthorizationService
  ) {
    super();
  }

  activeKeys: string[] = ['1', '2', '3', '4', '5', '6', '7'];
  allPanelsExpanded = false;
  showModifiedBy = true;

  ngOnInit(): void {
    this.entry = this.userService.getLeadEntry() ?? '';
    this.sectionsService.setFlow(this.entry)
    this.isParticipant = this.entry === 'participantEnrollment';
    this.isAssociationsEditable = this.readonly ? false : this.authUtility.isSectionEditable(this.pageId, this.tabId, TABS.Associations);
    this.drActionsAllowed = this.authUtility.isSectionEditable(this.pageId, this.tabId, 'DRActionsAllowed');
    this.isAorEditable = this.authUtility.isSectionEditable(this.pageId, this.tabId, 'aor');
    this.isAorVisible = this.authUtility.isSectionVisible(this.pageId, this.tabId, 'aor');
    const providerType = this.sectionsService.getEnrollmentType();
    if (Array.isArray(providerType) && providerType.includes('provider')) {
      this.isPA = true;
    }
    this.newContactForm = this.fb.group({
      newEmployer: ['No'],
      newAuthRep: ['No'],
      newVendor: ['No'],
      newProvider: ['No'],
      newContractor: ['No'],
      newPOA: ['No'],
      newLegalGuardian: ['No'],
    });
    this.program = this.userService.getSelectedProgram();
    this.canBlockUnblock = this.userService.isSelectedRole('Compliance');
    this.leadId = this.userService.getSelectedLead();
    const steps = this.sectionsService.getSectionData('NY');
    this.secData = steps[this.isParticipant ? 'associations' : 'enrollment_status'];
    this.userDetails = this.userService.getUserDetails();
    
    const userType = this.userDetails?.usertype_lkp?.toLowerCase();
    if (userType && ['provider', 'participant'].includes(userType)) {
      this.showModifiedBy = false;
    }

     const isInRole = this.userService.isSelectedRole('PPL Staff Tier 1') && userType === 'fms';
    if (isInRole) {
      this.readonly = true;
    }
    this.getConsumerDetails();
    this.createFormGroup();
    if(!this.isParticipant){
      this.getWeeklyLimitData();
    }

    const controls = [
      'newEmployer',
      'newAuthRep',
      'newProvider',
      'newVendor',
      'newContractor',
      'newLegalGuardian',
      'newPOA',
    ];

    controls.forEach((control) => {
      this.newContactForm.get(control)?.valueChanges.subscribe((value) => {
        this.onRadioChange(control, value);
      });
    });

    this.getGridHeaders()
    this.enrollmentDataService.getParticipantAssocChanged().subscribe(() => {
      this.getAssociationDetails(this.program.program_code, this.leadId);
    })
    this.enrollmentStatus.get('endDate')?.valueChanges.subscribe(() => {
      this.updateMinStartDate();
    });
    this.enrollmentStatus.get('startDate')?.valueChanges.subscribe(() => {
      this.updateMaxEndDate();
    });

    this.statusReasons = this.lookupService.getLookupValue(
      'enr_status_reason'
    );
  }

  getWeeklyLimitData(): void {
    const payload = {
      "pageName": "weekly-limit-pa",
      "programCode": "NY",
      "condition": "and",
      "recordsPerPage": 20,
      "startingPageNumber": 1,
      "searchParam": [
        {
          jsonPath: "providerId",
          value: this.leadId,
          operator: "Equal"
        }
      ],
      "orderByColumn": ["startDate", "tasAuthorizationXProviderId"],
      "orderBy": [
        "asc", "desc"
      ]
    };
  
    this.listService.getListData(payload).subscribe((data: any) => {
      if (data.status === 200) {
        this.weeklyLimitData = data.responsedata.map((item: any) => ({
          ...item,
          hoursFormatted: item.servicecodeDetailId ? item.hoursFormatted : null,
          actions: {
            history: item.servicecodeDetailId,
          },
        }));
      }
    });
  }

  getAssociationDetails(program_code: string, leadId: any, isWriteRequest = false) {
    this.enrollmentDataService.getAssociationsDetails(program_code, leadId, this.isParticipant, isWriteRequest).subscribe((response: any) => {
      console.log(response.responsedata);
      const data = response.responsedata;
      this.assocData = response.responsedata;
      // participantAssociations
      if (this.isParticipant) {
        for (const key in PROVIDER_TYPES) {
          this.associationDetailsData[key] = data[key] || [];
        }
      } else {
        this.prvdrAssociations = data.participantAssociations;
        this.prvdrAssociations.forEach((association: any) => {
          association.actions = {
            showStatus: !this.readonly
          };

          if (association.providerType === 'AR') {
            const allowedStatusToManageConsumer = ['Association Active', 'Association Active with Gap', 'Paperwork Complete'];
            if (this.isMinorDob(association.participantDob)) {
              allowedStatusToManageConsumer.push('In PPL Review');
            }
            association.actions.manageConsumer = !this.readonly && allowedStatusToManageConsumer.includes(association.associationStatus) && association.drRequired !== 'Not Applicable';
          }

          if (association.providerType === 'IR') {
            association.actions.block = !this.readonly && this.canBlockUnblock && !association.isSsnBlockedOnParticipant;
            association.actions.unblock = !this.readonly && this.canBlockUnblock && association.isSsnBlockedOnParticipant && !association.isSsnBlockedOnAll;
          }

          if (association.associationStatus == 'Disassociated') {
            association.actions = {
              ...association.actions,
              manageConsumer: false
            }
          }
          if (this.isAorVisible && data.basicInfo?.healthAssessmentStatus === 'fail' && (association.associationStatus === 'In PPL Review' || association.associationStatus === 'Paperwork Complete')) {
            association.actions = {
              ...association.actions,
              aorWaiver: true
            }
          }
        });
        console.log('this.prvdrAssociations', this.prvdrAssociations);
      }

    });
  }

  private isMinorDob(dob?: string): boolean {
    if (!dob) {
      return false;
    }
    const [month, day, year] = dob.split('/').map(Number);
    const birthDate = new Date(year, month - 1, day);
    if (isNaN(birthDate.getTime())) {
      return false;
    }
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age < 18;
  }

  getProviderAssoc(program_code: string, leadId: any) {
    this.enrollmentDataService.fetchProviderAssociations(program_code, leadId).subscribe((response: any) => {
      console.log(response);

    })
  }

  async getGridHeaders() {
    try {
      if (this.entry) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(
          this.entry === 'participantEnrollment' ? STATIC_JSON_DATA_PATH.ASSOCIATIONS_DETAILS_HEADERS : STATIC_JSON_DATA_PATH.PROVIDER_ASSOCIATIONS_HEADERS, this.entry
        );
        console.log(tempCols.columns);
        this.cols = tempCols.columns;

        if (this.entry != 'participantEnrollment') {
          const statusCols = await this.sectionsService.getJsonConfigurationData(STATIC_JSON_DATA_PATH.PROVIDER_ASSOCIATIONS_STATUS_HEADERS, this.entry);
          this.statusCols = statusCols.enrollmentStatus.columns;
          const userType = this.userDetails?.usertype_lkp?.toLowerCase();
          if (userType && ['provider', 'participant'].includes(userType)) {
            this.statusCols = this.statusCols.filter((data: any) => data.jsonpath !== 'modifiedBy');
          }
        }
      }
    } catch (e) {
      this.logger.debug('Communication logs - Error in getting column data', e);
    }

  }

  goToConsumer(consumerDetail: any) {
    const program = this.userService.getSelectedProgram();
    this.userService.setLeadEntry('participantEnrollment');
    this.sectionsService.setFlow('participantEnrollment');
    this.referralDataService.clearReferrralData();
    this.userService.setSelectedLead(consumerDetail.participantId);
    this.leadDetailsService
      .fetchLeadDetailsApi(
        'participantEnrollment',
        program?.program_code ?? '',
        consumerDetail.participantId
      )
      .subscribe((data: any) => {
        this.referralDataService.setReferralDetails(data.responsedata);
        this.userService.setParticipantPplId(data.responsedata?.infoData?.participantPPLId)
        if (data?.responsedata?.infoData?.applicationStatus == "In Progress" || data?.responsedata?.infoData?.applicationStatus == "New Application") {
          this.sectionsService.setEnrollmentType(JSON.stringify([]));
          setTimeout(() => {
            this.storageService.setParticipantId(data?.responsedata?.infoData.participantId);
            this.storageService.setParticipantPPLId(data.responsedata?.infoData.participantPPLId);
            this.storageService.setTrackingNumber(data.responsedata?.infoData.trackingNumber);
            this.router.navigate(['/newReferral']);
          }, 200);
        } else {
           this.userService.setFirstSegment('participantEnrollmentList');
          setTimeout(() => {
            this.router.navigate(['/home/participantEnrollmentList/details/'],
              {
                state: {
                  navigateToTab: 'summary',
                  leadId: this.leadId,
                  providerType: this.sectionsService.getEnrollmentType()
                }
              }
            );
          }, 200);
        }
      });

  }


  action(event: any): void {
    this.logger.debug('Action', event);

    if (event.action == 'showStatus') {
      const data = event.data;
      this.modalBody = 'Enrollment Dates and Status - ' + data.participantFirstName + ' ' + data.participantLastName + ' (' + data.participantPplId + ")";
      this.showModal = true;
      this.selectedAssociationId = data.participantProviderAssociationId;
      this.getAssociationStatus(data.associationStatus);
      this.updateAssociationStatus(data.associationStatus);
      const dialogConfig: DialogConfig = {
        title: this.modalBody,
        isOkText: 'Save',
        size: 'xx-large',
        position: 'top',
        showClose: true,
        showButtons: false,
      };
  
      this.dialogSvc.openDialog(
        this.manageStatus,
        dialogConfig,
        () => this.handleCancel(),
        () => this.handleCancel()
      );
      
    }

    if (event.action === 'aorWaiver') {
      this.selectedAorAssociationId = event.data.participantProviderAssociationId;
      const dialogConfig: DialogConfig = {
        title: 'AOR',
        isOkText: 'Save',
        size: 'x-large',
        position: 'top',
        showClose: true,
        showButtons: false,
        styleClass: 'aor-waiver-dialog',
      };

      this.dialogSvc.openDialog(
        this.aorWaiverDialog,
        dialogConfig,
        () => this.handleCancel(),
        () => this.handleCancel()
      );
    }
    if (event.action == 'manageConsumer') {
      const data = event.data;
      this.goToConsumer(data);
    }
    if (event && event.action === 'edit') {
      this.mode = 'edit';
      if (event?.data) {
        this.updateStatusEntries();
        const data = JSON.parse(JSON.stringify(event?.data));
        data.startDate = new Date(data.startDate);
        if (data.endDate) {
          data.endDate = new Date(data.endDate);
        }
        this.enrollmentStatus.patchValue(data);
      }
    }
    if (event && event.action === 'history') {
      this.openHistoryDialog(event.data);
    }
    if (event && event.action === 'block') {
      const SSNData = this.assocData.basicInfo.identifiers.filter((data: any) => data.type === 'SSN');
      const existingIds: string[] = SSNData[0]?.addlVal2
        ? SSNData[0].addlVal2.toString().split(',').map((id: string) => id.trim()).filter(Boolean)
        : [];
      const newId = event.data.participantProviderAssociationId.toString();
      const allIds = existingIds.includes(newId) ? existingIds : [...existingIds, newId];
      this.pendingBlockPayload = {
        id: event.data.providerId,
        identifierId: event.data.ssnIdentifierId,
        programCode: this.program.program_code,
        identifier: {
          type: SSNData[0]?.type ?? 'SSN',
          value: SSNData[0]?.value,
          modifiedDate: SSNData[0]?.modifiedDate,
          addlVal1: 'blocked',
          addlVal2: allIds.join(',')
        }
      };
      this.openBlockConfirmDialog(event.data.providerId);
    }
    
        if (event && event.action === 'unblock') {
          const SSNData = this.assocData.basicInfo.identifiers.filter((data: any) => data.type === 'SSN');
          const currentIds: string[] = SSNData[0]?.addlVal2
            ? SSNData[0].addlVal2.toString().split(',').map((id: string) => id.trim())
            : [];
          const remainingIds = currentIds.filter(id => id !== event.data.participantProviderAssociationId.toString());
          const payload: LeadDetailIdentifiersAddUpdateModel = {
            id: event.data.providerId,
            identifierId: event.data.ssnIdentifierId,
            programCode: this.program.program_code,
            identifier: {
              type: SSNData[0]?.type ?? 'SSN',
              value: SSNData[0]?.value,
              modifiedDate: SSNData[0]?.modifiedDate,
              addlVal1: remainingIds.length > 0 ? 'blocked' : null,
              addlVal2: remainingIds.length > 0 ? remainingIds.join(',') : null
            }
          };
          this.leadDetailsService.blockUnblockIdentifier(payload, this.entry, 'Unblocked PA for this consumer.').subscribe(() => {
            this.getAssociationDetails(this.program.program_code, event.data.providerId, false)
          });
      }
  }

  openBlockConfirmDialog(id: any) {
    const dialogConfig: DialogConfig = {
      title: 'Confirmation',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
      isOkText: 'Yes',
      cancelText: 'No',
    };
    this.blockConfirmDialogId = this.dialogSvc.openDialog(
      this.blockConfirmDialog,
      dialogConfig,
      () => this.confirmBlock(id),
      () => { this.pendingBlockPayload = null; this.blockConfirmDialogId = null; }
    );
  }

  confirmBlock(id: any) {
    if (this.pendingBlockPayload) {
      this.leadDetailsService.blockUnblockIdentifier(this.pendingBlockPayload, this.entry, 'Blocked PA for this consumer.').subscribe(() => {
        this.getAssociationDetails(this.program.program_code,id, false)
      });
    }
    this.pendingBlockPayload = null;
    this.blockConfirmDialogId = null;
  }

  getConsumerDetails() {
    this.leadDetailsService
      .getLeadDetails(this.entry, this.program.program_code, this.leadId, true)
      .subscribe((data: any) => {
        this.consumerData = data?.responsedata?.infoData;
      });
  }

  getAssociationStatus(status: string = this.participantStatus) {
    this.enrollmentDataService.getAssociationStatus(this.program?.program_code, this.selectedAssociationId).subscribe((data: any) => {
      this.prvdrAssociationsStatus = data?.responsedata;
      if (status === 'Disassociated') {
        return;
      }
      this.prvdrAssociationsStatus.forEach((data: any) => {
        if (data.startDate && data.endDate) {
          if (new Date().getTime() < new Date(data.endDate).getTime()
            &&
            new Date().getTime() > new Date(data.startDate).getTime()) {
            data.actions = {
              edit: true
            }
          }
        }

        if (data.startDate) {
          if (new Date().getTime() < new Date(data.startDate).getTime()) {
            data.actions = {
              edit: true
            }
          }
        }
      });
    });
  }

  getProviderData(providerCode: string) {
    const userOrgId = this.userDetails?.belongsto_org;
    const isMCOUser = this.userDetails?.usertype_lkp?.toLowerCase() === 'mco';
    let restrictForMCO = false;
    if (isMCOUser) {
      const activeMCOs: number[] | null = this.consumerData?.activeMCOs ?? null;
      restrictForMCO = !activeMCOs || !activeMCOs.includes(userOrgId);
    }
    const data = this.associationDetailsData[providerCode] || [];
    data.forEach((e: any) => {
      e.disabled = !this.allowedStatuses.includes(e.associationStatus) || !this.drActionsAllowed || restrictForMCO || this.consumerData?.drReqStatus?.toLowerCase() === 'not applicable' ;
      e.actions = {};
        if (e.associationStatus !== 'Disassociated') {
          e.actions.showDisassociate = true;
          if (providerCode === 'AR') {
            e.actions.approve = true;
            e.actions.reject = true;
          }
        }
    });
    return data;
  }

  actionSelected(event: any){
    if(event === 'DR request changed'){
      this.getConsumerDetails();
    }
    else if (event == 'Association deleted') {
      this.getAssociationDetails(this.program.program_code, this.consumerData.participantId, false)
    }
    else{
      this.getAssociationDetails(this.program.program_code, this.consumerData.participantId, false)
      this.getProviderData('AR');
    }
  }

  getProviderColumns(providerCode: string) {
    if (!['AR', 'IR', 'LG', 'POA'].includes(providerCode)) {
      let data = this.cols.filter((e: any) => e.field != 'relationToParticipant');
      return data;
    }

    return this.cols;
  }

  onRadioChange(controlName: string, value: string) {
    if (value === 'Yes') {
      this.referralDataService.setFlowForAssociation({ val: true, flow: controlName });
    }
  }

  add(control: string) {
    this.referralDataService.setFlowForAssociation({ val: true, flow: control });
  }

  hideAll() {
    this.activeKeys = [];
  }

  expandAll() {
    this.activeKeys = ['1', '2', '3', '4', '5', '6', '7'];
  }

  togglePanel(key: string): void {
    if (this.isPanelActive(key)) {
      this.activeKeys = this.activeKeys.filter((k) => k !== key);
    } else {
      this.activeKeys.push(key);
    }
  }

  isPanelActive(key: string): boolean {
    return this.activeKeys.includes(key);
  }

  handleCancel() {
    this.showModal = false;
    this.modalBody = '';
    this.selectedAssociationId = '';
    this.mode = 'read';
    this.showMoveToInPPLReviewButton = false;
    this.disableStatus = false;
  }

  openHistoryDialog(data: any){
    const payload = {
      "participantId": data.participantId,
      "providerId": data.providerId,
      "servicecodeDetailId": data.servicecodeDetailId,
      "sourceOrgId": data.orgId
  }
    this.authorizationService.getWeeklyLimitHistory(this.program.program_code, payload).subscribe((data: any)=>{
      this.historyData = data.responsedata;
      const dialogConfig: DialogConfig = {
        title: 'Weekly Limit History',
        isOkText: 'Ok',
        size: 'x-large',
        position: 'top',
        showClose: true,
        showButtons: false,
        styleClass: 'split-auth-data'
      };
  
      this.dialogSvc.openDialog(
        this.historyDialog,
        dialogConfig,
        () => this.handleHistoryCancel(),
        () => this.handleHistoryCancel()
      );
    })

  }

  handleHistoryCancel(){}

  save() {
    if (this.mode == 'add') {
      const data = { ...this.enrollmentStatus.value };

      data.startDate = this.dateFormatter.formatToString(data.startDate);

      if (data.endDate) {
        data.endDate = this.dateFormatter.formatToString(data.endDate);
      }

      try {
        this.validationErrors = performValidation(data, this.secData, 'Save', undefined, undefined, this.sectionsService.getFlow(), this.sectionsService.getEnrollmentType());
      } catch (e) {
        this.logger.debug('Error in validations', e);
      }

      if (Object.keys(this.validationErrors).length === 0) {
        this.enrollmentDataService
          .createEnrollmentStatus(data, this.program?.program_code, this.selectedAssociationId, true)
          .subscribe(() => {
            this.logger.info('Status information saved successfully');
            this.cancelEdit();
            this.getAssociationStatus();
            this.disableStatus = false;
            this.getAssociationDetails(this.program.program_code, this.leadId, true);
            this.handleCancel();
            setTimeout(() => {
              if (this.addStatusBtn?.nativeElement) {
                this.addStatusBtn.nativeElement.focus();
              }
            }, 0);
          });
      }
    } else if (this.mode == 'edit') {
      this.updateStatus();
    }
  }

  updateStatus() {
    const formValues = this.enrollmentStatus.value;
    const data: any = {};
    data.associationId = formValues.associationId;
    data.statusId = formValues.statusId;
    data.status = formValues.status;
    data.reason = formValues.reason;
    data.comment = formValues.comment;
    data.startDate = this.dateFormatter.formatToString(formValues.startDate);
    if (formValues.endDate) {
      data.endDate = this.dateFormatter.formatToString(formValues.endDate);
    }
    this.enrollmentDataService
      .updateEnrollmentStatus(data, this.program?.program_code, formValues.associationId)
      .subscribe(() => {
        this.logger.info('Status information updated successfully');
        this.cancelEdit();
        this.getAssociationStatus();
        this.disableStatus = false;
        this.getAssociationDetails(this.program.program_code, this.leadId, false);
        this.handleCancel();
      });
  }

  moveToPPLReview(): void {
    this.allowedStatus = [
      {
        status: "In PPL Review"
      }
    ];

    this.addStatus();
    this.enrollmentStatus.patchValue({
      startDate: new Date(),
      status: 'In PPL Review'
    });
    this.disableStatus = true;
  }


  disabledStartDate = (startValue: Date): boolean => {
    const endDate = this.enrollmentStatus.get('endDate')?.value;
    if (!startValue || !endDate) {
      return false;
    }
    return startValue.getTime() > endDate.getTime();
  };

  updateMinStartDate(): void {
    const endDate = this.enrollmentStatus.get('endDate')?.value;
    if (endDate instanceof Date) {
      const nextDay = new Date(endDate);
      nextDay.setDate(nextDay.getDate() - 1);
      this.minStartDate = nextDay;
    } else {
      this.minStartDate = undefined;
    }
  }

  updateMaxEndDate(): void {
    const startDate = this.enrollmentStatus.get('startDate')?.value;
    if (startDate instanceof Date) {
      const nextDay = new Date(startDate);
      nextDay.setDate(nextDay.getDate() + 1);
      this.maxEndDate = nextDay;
    } else {
      this.maxEndDate = undefined;
    }
  }

  disabledEndDate = (endValue: Date): boolean => {
    const startDate = this.enrollmentStatus.get('startDate')?.value;
    if (!endValue || !startDate) {
      return false;
    }
    return endValue.getTime() <= startDate.getTime();
  };

  createFormGroup() {
    this.enrollmentStatus = this.fb.group({
      statusId: [],
      associationId: [],
      startDate: [],
      endDate: [],
      status: [],
      comment: [],
      reason: []
    });
  }

  addStatus() {
    this.mode = 'add';
    this.enrollmentStatus.reset();
    this.enrollmentStatus.controls['associationId'].setValue(this.selectedAssociationId);
    this.updateStatusEntries();
  }


  updateAssociationStatus(status: string) {
    this.participantStatus = status;
    
    this.showMoveToInPPLReviewButton = false;
    this.disableAddStatus = false;
    if ((environment.isExternal && this.userDetails?.usertype_lkp?.toLowerCase() != 'state' ) || this.participantStatus === 'New Application' || this.participantStatus === 'In Progress' || this.participantStatus === 'Returned' || this.participantStatus === 'Disassociated') {
      this.disableAddStatus = true;
    }

    let isEditable = this.authUtility.isSectionEditable(this.pageId, this.tabId, 'AssociationsStatus');
    if (!isEditable) {
      this.disableAddStatus = true;
    }

    if (this.participantStatus === 'Returned' || this.participantStatus === 'In Progress') {
      this.showMoveToInPPLReviewButton = true;
    }

    this.updateStatusEntries();
  }

  cancelEdit() {
    this.mode = 'read';
    this.validationErrors = {};
    this.enrollmentStatus.reset();
    this.disableStatus = false;
  }

  updateStatusEntries() {
    if (this.participantStatus === 'Registration Inactive') {
      this.allowedStatus = [
        {
          status: "In PPL Review"
        }
      ];
    } else {
      this.allowedStatus = this.statusEntries.filter(s => s.status != this.participantStatus);
    }
  }
}
